import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../../../shared/firebase';

/**
 * Marks the tutorial as completed on the user's Firestore profile.
 * Fire-and-forget is fine — local state is updated synchronously before this call.
 */
export async function markTutorialCompleted(userId) {
  try {
    await updateDoc(doc(db, 'users', userId), { tutorialCompleted: true });
  } catch (err) {
    console.warn('[Tutorial] Failed to persist tutorial completion:', err.message);
  }
}
